import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  formatSessionNameForURL,
  isWindowInIframe,
  replaceDashesWithSpaces,
} from "../../v2_actions/nav";

import DesktopEventList from "./DesktopEventList";
import { EventsLayout } from "../layout/EventsLayout";
import LoadingSpinner from "../../views/components/LoadingSpinner";
import MobileEventList from "../MobileEventList";
import ReactGA from "react-ga4";
import { setGalleryNavBackButtonUrl } from "../../v2_actions/nav";
import { useEventFiltersDispatcher } from "../hooks/useEventFiltersDispatcher";
import { useGalleryFilterSearchParams } from "../hooks/useGalleryFilterSearchParams";
import { useIsMobile } from "../../actions/ui";
import { albumListForEventTab } from "../../v2_actions/customer_album";
import { briefGalleryList } from "../../v2_actions/brief_gallery";
import { briefGalleryEventList } from "../../v2_actions/brief_gallery_event";

const GALLERY_EVENT_PAGE_SIZE = 72;
const BRIEF_GALLERY_PAGE_SIZE = 24;

export const PhotographerEventsPage = () => {
  setGalleryNavBackButtonUrl();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const isInIframe = isWindowInIframe();
  const eventPageCtx = useEventFiltersDispatcher();
  const { country, photographerNickName } = useParams();
  const [searchParams] = useGalleryFilterSearchParams();

  useEffect(() => {
    dispatch(
      briefGalleryEventList.updatePaginationNumItemsPerPage(GALLERY_EVENT_PAGE_SIZE),
    );
    dispatch(
      briefGalleryList.updatePaginationNumItemsPerPage(BRIEF_GALLERY_PAGE_SIZE),
    );
  },[])

  useEffect(() => {
    const baseFilter = {
      gallery_type: undefined,
      gallery_event: undefined,
      gallery_event_name: undefined,
      album: undefined,
      has_gallery_event: true,
      any_field: searchParams.any,
      activity_tags: undefined,
      shot_at_date_from: undefined,
      shot_at_date_to: undefined,
      photographers: photographerNickName,
      country: country,
      private_event_token: '',
      public_or_direct_url: '',
      exclude_galleries_with_an_album: true,
    }

    eventPageCtx.updateBriefGalleryFilter({
      ...baseFilter,
    }, { skipGalleryEventFetch: true });

    dispatch(briefGalleryEventList.updateListFilter({
      photographers: photographerNickName,
      country: country,
      any_field: searchParams.any,
    }));
    dispatch(briefGalleryEventList.fetchListIfNeeded({
      callSource: "PhotographerEventsPage_briefGalleryEvent",
      forceUpdate: true,
    }));

  },[country, photographerNickName, searchParams.any])

  return (
    <EventsLayout activeTab="events" isInIframe={isInIframe}>
      <Box
        sx={{ margin: "auto", flexGrow: 1, width: "95%" }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ paddingTop: "3rem !important" }}>
            <DesktopEventList photographerMode={true} />
          </Grid>
        </Grid>
      </Box>
    </EventsLayout>
  );
};
